import thumbnail from 'cccisd-laravel-assignment/dist/components/navigations/withModules/withModules.png';
import Mediator from './Mediator.js';

export default {
    handle: 'moduleCampAir',
    label: 'Camp Air',
    thumbnail,
    mediatorComponent: Mediator,
};
